import Debug from '@/views/Debug.vue';
import stepsRoutes from '@/router/stepsRoutes';
import thankYouRoutes from '@/router/thankYouRoutes';
import childStepRoutes from '@/router/childStepRoutes';
import eSignaturesRoutes from '@/router/eSignaturesRoutes';

const locale = process.env.NODE_ENV === 'production' ? process.env.LOCALE : process.env.VUE_APP_I18N_FALLBACK_LOCALE;

/*
* Route which should be visible in progress bar
* have to have label and icon in meta object.
* */
const routes = [
  ...stepsRoutes,
  ...thankYouRoutes,
  ...childStepRoutes,
  ...eSignaturesRoutes,
  {
    name: 'Other',
    path: '*',
    redirect: '/landing-page',
    meta: {
      redirectEN: '/landing-page',
      redirectUA: '/landing-page',
      redirectRU: '/landing-page',
    },
  },
];

if (JSON.parse(process.env.VUE_APP_DEBUG_AVAILABLE).some((origin) => origin === window.location.origin)) {
  routes.push({
    name: 'Debug',
    path: '/debug',
    component: Debug,
    meta: {
      pathEN: '/debug',
      pathUA: '/debug',
      pathRU: '/debug',
      step: 1,
      ga: {
        virtualPagePath: '/uzp',
        virtualPageTitle: '',
      },
    },
  });
}

export default routes.map((route) => {
  const l = locale.toUpperCase();
  const meta = { ...route.meta, label: route.meta[`label${l}`] };
  if (l === 'SK') return { ...route, meta };
  if (route.redirect) return { ...route, redirect: route.meta[`redirect${l}`] };
  return { ...route, path: route.meta[`path${l}`], meta };
});
